// extracted by css-extract-rspack-plugin
export default {"root":"c6wiEatNR6Iehtlj","tags":"xM1qauMPs7sY23Ln","customOption":"aWquUJVSNSkE7xP2","noOptions":"XwJZg5LptgX4dkCM"};